import { useCallback } from 'react';
import type { MyProductReviewAnswer } from '../../../../../music24-api/src/productReviews/productReviewTypes';
import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';

/** `reviews.mine`: the review of the signed-in user (null when none) and the default name. */
export function useMyReview() {
  const trpcAPI = useTRPCAPI();
  const {
    data,
    isLoading,
    error,
    refetch: refetchUnsafe,
  } = useTRPCQuery(trpcAPI.reviews.mine.queryOptions(undefined, { retry: false }));

  const refetch = useCallback(() => {
    refetchUnsafe().catch(console.error);
  }, [refetchUnsafe]);

  return {
    answer: data as MyProductReviewAnswer | undefined,
    isLoading,
    error: error ?? undefined,
    refetch,
  };
}
